<template>
  <Loading v-if="isLoading" class="wrapper centered" />
  <component :is="layout" v-else class="wrapper">
    <router-view />
  </component>
</template>

<script>

import Loading from './components/Layout/Loading';
import LayoutManagement from './components/Layout/LayoutManagement/Layout';
import LayoutOperative from './components/Layout/LayoutOperative/Layout';
import LayoutModal from './components/Layout/LayoutModal/Layout';
import SidebarEffectorMixin from '../libs/Sidebar/mixins/sidebarEffector';

export default {
  name: 'app',
  components: {
    Loading,
  },
  mixins: [
    SidebarEffectorMixin,
  ],
  data () {
    return {
      loading: true,
      feedback: true,
    };
  },
  computed: {
    isLoading () {
      return this.loading;
    },
    isLogged () {
      return this.$oauth2.me;
    },
    layoutName () {
      return this.$route?.meta?.layout || 'management';
    },
    layout () {
      if (this.layoutName === 'modal') {
        return LayoutModal;
      }

      if (this.layoutName === 'operative') {
        return LayoutOperative;
      }

      return LayoutManagement;
    },
  },
  mounted () {
    this.$oauth2.getMe().then(() => {
      this.loading = false;
    });
  },
};

</script>

<style lang="scss">

$min-width: 240px !default;

.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: $min-width;
}

main {
  overflow: auto;
}

body.show-mobile-menu {
  overflow: hidden;
}

.truncated-text {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fab-container {
  bottom: 5%;
  right: 5%;
  position: fixed;
}

</style>
